/**
 * Page de profil utilisateur
 * @module pages/Profile
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useProfile } from './hooks/useProfile';
import '../App.css';

/**
 * Composant de la page de profil
 * @returns {JSX.Element}
 */
function Profile() {
  const { user, loading, error, handleLogout } = useProfile();

  if (loading) {
    return (
      <div className="page-container">
        <div className="card" style={{ textAlign: 'center' }}>
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <span>Chargement des informations...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="card" style={{ textAlign: 'center' }}>
          <div className="error-state">
            <span>{error}</span>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="page-container">
        <div
          className="card"
          style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}
        >
          <h1 className="card-title" style={{ marginBottom: '1rem' }}>
            Profil Twitch
          </h1>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
            Aucune chaîne Twitch n’est liée à votre compte, ou les données ne
            sont pas encore disponibles. Connectez Twitch depuis l’accueil.
          </p>
          <Link to="/" className="button">
            Retour à l’accueil
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div className="card-header">
          <h1 className="card-title">Profil Twitch</h1>
        </div>

        {user.profile_image_url ? (
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img
              src={user.profile_image_url}
              alt={`${user.display_name} avatar`}
              loading="lazy"
              style={{
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                border: '4px solid var(--twitch-purple)',
                boxShadow: 'var(--shadow-purple)',
                marginBottom: '1.5rem',
              }}
            />
          </div>
        ) : null}

        <div className="section">
          <div
            style={{
              padding: '1rem',
              background: 'var(--bg-tertiary)',
              borderRadius: 'var(--border-radius-md)',
              marginBottom: '1rem',
            }}
          >
            <p style={{ margin: '0.5rem 0' }}>
              <strong style={{ color: 'var(--twitch-purple)' }}>
                Pseudo :
              </strong>{' '}
              <span style={{ color: 'var(--text-secondary)' }}>
                {user.display_name}
              </span>
            </p>
            <p style={{ margin: '0.5rem 0' }}>
              <strong style={{ color: 'var(--twitch-purple)' }}>ID :</strong>{' '}
              <span style={{ color: 'var(--text-muted)' }}>{user.id}</span>
            </p>
            <p style={{ margin: '0.5rem 0' }}>
              <strong style={{ color: 'var(--twitch-purple)' }}>Nom :</strong>{' '}
              <span style={{ color: 'var(--text-secondary)' }}>
                {user.login}
              </span>
            </p>
            <p style={{ margin: '0.5rem 0' }}>
              <strong style={{ color: 'var(--twitch-purple)' }}>
                Description :
              </strong>{' '}
              <span style={{ color: 'var(--text-secondary)' }}>
                {user.description || 'Aucune description'}
              </span>
            </p>
            <p style={{ margin: '0.5rem 0' }}>
              <strong style={{ color: 'var(--twitch-purple)' }}>
                Compte créé le :
              </strong>{' '}
              <span style={{ color: 'var(--text-secondary)' }}>
                {user.created_at
                  ? new Date(user.created_at).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : '—'}
              </span>
            </p>
          </div>
        </div>

        <button
          className="button"
          onClick={handleLogout}
          style={{ width: '100%', marginTop: '1rem' }}
        >
          Déconnexion
        </button>
      </div>
    </div>
  );
}

export default Profile;
